import Vue from "vue"
import Antd from "ant-design-vue"
import "../assets/styles/_variables.less"

Vue.use(Antd)
